const PAGE_ANIMATION = 'fadeIn';

const MAX_SEARCH_ROOMS = 4;
const MULTIPLE_ROOMS = {
  FIRST: '1',
  SECOND: '2',
  THIRD: '3',
  FOURTH: '4',
};

const PRICE_TYPE = {
  AVG: 'avg',
  TOTAL: 'total',
};

const FREE_MODE_ID = 'FREE_MODE';
const FREE_MODE_DISTRIBUTION = 'ANY';

const CALL_CENTER_ROLE = 'CALL_CENTER';

const LONG_DAY_NAME = 'dddd'; // Domingo

// tpv-form methods. These correspond to the URLs defined in the API
const TPV_FORM_DEFAULT_METHOD = 'tpv-form';
const TPV_FORM_UPFRONT_PAYMENT_METHOD = 'tpv-upfront-payment-form';
const TPV_FORM_ADYEN = 'tpv-form-adyen';
const TPV_FORM_UPFRONT_ADYEN_PAYMENT_METHOD = 'tpv-upfront-adyen-payment-form';

// --- Chain Conf
const SANDOS_CHAIN = 'SANDOS';
const MARCONFORT_CHAIN = 'MARCONFORT';
const PALAMIA_CHAIN = 'PALMAIARESORTS';
const chains = [SANDOS_CHAIN, MARCONFORT_CHAIN, PALAMIA_CHAIN];
const chainGTMs = {
  SANDOS: {
    ua: 'UA-4155818-1',
    gtm: 'GTM-WBBDNC',
  },
  MARCONFORT: {
    ua: 'UA-5214702-1',
    gtm: 'GTM-WDPCT7',
  },
  PALMAIARESORTS: {
    ua: 'UA-134394191-1',
    gtm: 'GTM-PMPKK2F',
  },
};

const LOYALTY_COINS_DISABLED = 'disabled';
const LOYALTY_COINS_CALL_CENTER = 'call-center';
const LOYALTY_COINS_ENABLED = 'enabled';
const LOYALTY_NEW_USER_MAX_DISCOUNT_PERCENTAGE = 25;

const FIRST_ORDERED_BOARD_CODES = [
  'AI',
  'PC',
  'MP',
  'HD',
  'SA',
];

const EXTRA_CATEGORIES = {
  EXTRA: 'extras',
  RETREAT: 'retreat',
  TRANSFER: 'transfer',
};

const EXTRA_PAXTYPES = {
  ALL: 'all',
  NONE: 'no',
  ADULTS: 'ad',
  CHILDREN: 'ch',
  BABIES: 'bb',
};

const EXTRA_OPTIONAL_FIELDS = {
  ONEWAY: 'oneway',
  ONEWAYTOHOTEL: 'onewaytohotel',
  ONEWAYTOAIRPORT: 'onewaytoairport',
  ROUNDTRIP: 'roundtrip',
  DATEPICKER: 'datepicker',
  QUANTITYSELECTOR: 'quantityselector',
  TIMEPICKER: 'timepicker',
  PAXSELECTOR: 'paxselector',
};

const EXTRA_ARRIVAL_OR_DEPARTURE_DATE = {
  ARRIVAL: 'arrival',
  DEPARTURE: 'departure',
};

const DATE_FORMAT_ISO = 'YYYY-MM-DD';
const MONTH_YEAR_FORMAT_ISO = 'YYYY-MM';
const DATE_FORMAT_CUSTOMER = 'MMM D, YYYY';
const DATE_FORMAT_BK_DETAIL_CHECKIN = 'dddd MMMM DD';
const DATE_FORMAT_BK_DETAIL_CHECKOUT = 'MMMM DD, YYYY';
const DATE_FORMAT_CUSTOMER_DAY = 'ddd, MMM D';
const DATE_FORMAT_MONTH_DAY = 'MMM D';
const TIME_FORMAT_HOUR_MINUTE_A = 'h:mm A';

export {
  PAGE_ANIMATION,
  MAX_SEARCH_ROOMS,
  MULTIPLE_ROOMS,
  FREE_MODE_ID,
  FREE_MODE_DISTRIBUTION,
  CALL_CENTER_ROLE,

  chains,
  SANDOS_CHAIN,
  MARCONFORT_CHAIN,
  PALAMIA_CHAIN,
  chainGTMs,

  TPV_FORM_DEFAULT_METHOD,
  TPV_FORM_UPFRONT_PAYMENT_METHOD,

  TPV_FORM_ADYEN,
  TPV_FORM_UPFRONT_ADYEN_PAYMENT_METHOD,

  // Day date format
  LONG_DAY_NAME,
  PRICE_TYPE,

  LOYALTY_COINS_DISABLED,
  LOYALTY_COINS_CALL_CENTER,
  LOYALTY_COINS_ENABLED,
  LOYALTY_NEW_USER_MAX_DISCOUNT_PERCENTAGE,

  FIRST_ORDERED_BOARD_CODES,

  EXTRA_CATEGORIES,
  EXTRA_PAXTYPES,
  EXTRA_ARRIVAL_OR_DEPARTURE_DATE,
  EXTRA_OPTIONAL_FIELDS,

  DATE_FORMAT_ISO,
  MONTH_YEAR_FORMAT_ISO,
  DATE_FORMAT_CUSTOMER,
  DATE_FORMAT_BK_DETAIL_CHECKIN,
  DATE_FORMAT_BK_DETAIL_CHECKOUT,
  DATE_FORMAT_CUSTOMER_DAY,
  DATE_FORMAT_MONTH_DAY,
  TIME_FORMAT_HOUR_MINUTE_A,
};
